import { Avatar, AvatarFallback, AvatarImage } from "design-system/atoms/Avatar"
import { cn } from "design-system/utils"
import { useCompanyQuery } from "modules/settings/hooks/useCompanyQuery"
import { useMemo } from "react"

type Props = {
  className?: string
}

export function CompanyAvatar({ className }: Props) {
  const { data: company } = useCompanyQuery()

  const initials = useMemo(() => company?.name.slice(0, 1).toUpperCase(), [company?.name])

  return (
    <Avatar className={cn("h-8 w-8 rounded-md bg-muted", className)}>
      <AvatarImage src={company?.logo ?? undefined} alt={company?.name ?? undefined} />
      <AvatarFallback className="rounded-md bg-foreground/10">{initials}</AvatarFallback>
    </Avatar>
  )
}
